import {testIdProps} from '@github-ui/test-id-props'
import {ActionList, Box, themeGet} from '@primer/react'
import {SuggestionItem} from './SuggestionItem'
import {useFilter, useInput, useSuggestions} from '../context'
import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {useMemo} from 'react'

export const SuggestionsList = () => {
  const {id} = useFilter()
  const {suggestionsListRef, activeSuggestion, isFetchingSuggestions, position, suggestions, suggestionsVisible} =
    useSuggestions()
  const {suspendFocus} = useInput()

  const loadingSekeltons = useMemo(
    () => (
      <Box>
        {Array(6)
          .fill(1)
          .map((_, i) => (
            <Box
              key={`loading-skeleton-${i}`}
              sx={{display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 8px', lineHeight: '20px', mx: 2}}
            >
              <LoadingSkeleton variant="elliptical" width={'20px'} height={'20px'} />
              <LoadingSkeleton variant="rounded" width="random" height={'16px'} />
            </Box>
          ))}
      </Box>
    ),
    [],
  )

  return (
    <Box
      sx={{top: 5, left: 0, mt: 1, right: 0, zIndex: '999', position: 'absolute', backgroundColor: 'initial'}}
      {...testIdProps('backdrop-anchor')}
    >
      <Box
        id={`${id}-suggestions`}
        ref={suggestionsListRef}
        sx={{
          bg: 'canvas.overlay',
          borderRadius: '12px',
          boxShadow: 'overlay.shadow',
          display: 'flex',
          flexDirection: 'column',
          height: 'auto',
          left: ['0', '0', `${position ? position.left : 0}px`],
          maxHeight: `calc(100vh - 2rem)`,
          minWidth: '250px',
          position: 'absolute',
          opacity: suggestions.length > 0 && suggestionsVisible ? 1 : 0,
          transition: 'opacity 0.2s ease',
          visibility: suggestions.length > 0 && suggestionsVisible ? 'visible' : 'hidden',
          whiteSpace: 'normal',
          width: ['100%', 'min-content', 'min-content'],
        }}
        onMouseDown={e => suspendFocus(e.currentTarget)}
      >
        <Box
          sx={{
            p: 0,
            flexGrow: 1,
            fontSize: themeGet('primer.text.body.size.large') ?? '14px',
          }}
        >
          <ActionList
            {...testIdProps('filter-results')}
            aria-label={isFetchingSuggestions ? 'Loading Suggestions' : 'Suggestions'}
            id={`${id}-results`}
            sx={{
              maxHeight: '20em',
              overflowX: 'hidden',
              overflowY: 'auto',
              listStyle: 'none',
            }}
          >
            {isFetchingSuggestions
              ? loadingSekeltons
              : suggestions.map((s, i) => {
                  return <SuggestionItem {...s} id={i} key={`suggestion-${s.value}`} active={i === activeSuggestion} />
                })}
          </ActionList>
        </Box>
      </Box>
    </Box>
  )
}

try{ SuggestionsList.displayName ||= 'SuggestionsList' } catch {}